exports.components = {
  "component---src-lekoarts-gatsby-theme-cara-templates-cara-tsx": () => import("./../../../src/@lekoarts/gatsby-theme-cara/templates/cara.tsx" /* webpackChunkName: "component---src-lekoarts-gatsby-theme-cara-templates-cara-tsx" */),
  "component---src-pages-archive-branch-tsx": () => import("./../../../src/pages/archive/branch.tsx" /* webpackChunkName: "component---src-pages-archive-branch-tsx" */),
  "component---src-pages-archive-index-mdx": () => import("./../../../src/pages/archive/index.mdx" /* webpackChunkName: "component---src-pages-archive-index-mdx" */)
}

